/**
 * TODO:: depreacte this, replace usages with simpleModal
 * @deprecated
 */
function getModal(id) {
    return document.getElementById(id);
}

function initModal(id, target, size, options = {}) {
    const modal = document.createElement('div');
    modal.classList.add('modal', 'fade');
    if (options && options.modal && options.modal.class) {
        modal.classList.add(options.modal.class);
    }
    modal.setAttribute('id', id);
    modal.setAttribute('tabindex', '-1');
    modal.setAttribute('role', 'alertdialog');
    modal.setAttribute('aria-labelledby', id + 'Label');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
        '<div class="modal-dialog modal-' + size + ' modal-dialog-centered" role="document">' +
            '<div class="modal-content"></div>' +
        '</div>';
    document.querySelector(target).appendChild(modal);
    return modal;
}

export default function (id, target, size = 'md', title = '', body = '', buttons = '', options = {})
{
    let modal = getModal(id);
    if (!modal) {
        modal = initModal(id, target, size, options);
    }
    const titleTag = options && options.title && options.title.tag ? options.title.tag : 'h2';
    const html =
        '<div class="modal-header">' +
            '<' + titleTag + ' class="modal-title" id="' + id + 'Label">' + title + '</' + titleTag + '>' +
            '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                '<span><svg class="svg-sprite window-close" [data-action="close"] viewBox="0 0 27 27" aria-label="Close"><title>Close</title><use xlink:href="#icon-close"></use></svg></span>' +
            '</button>' +
        '</div>' +
        '<div class="modal-body">' +
            body +
        '</div>' +
        '<div class="modal-footer">' +
            buttons +
        '</div>';
    modal.querySelector('.modal-content').innerHTML = html;

    jQuery(modal).modal('show');

    return modal;
}
